import axiosInstance from '../api/axios';

const handleRequest = async (apiCall, setLoading, setData, setError, filters = {}, pagination = {}) => {
  setLoading(true);
  setError(null);
  try {
    const params = { ...filters, ...pagination };
    const response = await apiCall(params);
    setData(response.data);
    return { data: response.data, error: null };
  } catch (error) {
    // error.message is calm, translated text from the API error interceptor
    setError(error?.message || error?.data?.error || null);
    return { data: null, error };
  } finally {
    setLoading(false);
  }
};

//auth
export const register = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/register', data), setLoading, setData, setError);
};

export const login = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/login', data), setLoading, setData, setError);
};

export const refresh = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/refresh'), setLoading, setData, setError);
};

export const getProfile = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get('/api/v1/auth/profile'), setLoading, setData, setError);
};

export const changePassword = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/change-password', data), setLoading, setData, setError);
};

export const logout = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/logout'), setLoading, setData, setError);
};

export const verifyEmail = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/verify-email', data), setLoading, setData, setError);
};

export const resendVerification = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/resend-verification'), setLoading, setData, setError);
};

export const forgotPassword = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/forgot-password', data), setLoading, setData, setError);
};

export const resetPassword = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/auth/reset-password', data), setLoading, setData, setError);
};

export const googleAuth = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get('/api/v1/auth/google'), setLoading, setData, setError);
};

export const googleAuthCallback = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get('/api/v1/auth/google/callback'), setLoading, setData, setError);
};

//users
export const getUsers = (filters, pagination, setLoading, setData, setError) => {
  return handleRequest((params) => axiosInstance.get('/api/v1/users', { params }), setLoading, setData, setError, filters, pagination);
};

export const getUserById = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get(`/api/v1/users/${id}`), setLoading, setData, setError);
};

export const updateUser = (id, data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.patch(`/api/v1/users/${id}`, data), setLoading, setData, setError);
};

export const deleteUser = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.delete(`/api/v1/users/${id}`), setLoading, setData, setError);
};

export const bulkUpdateUserStatus = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/users/bulk/status', data), setLoading, setData, setError);
};

export const bulkUpdateUserRole = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/users/bulk/role', data), setLoading, setData, setError);
};

export const getUserStatsOverview = (setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get('/api/v1/users/stats/overview'), setLoading, setData, setError);
};

export const resetUserPassword = (id, data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post(`/api/v1/users/${id}/reset-password`, data), setLoading, setData, setError);
};

export const impersonateUser = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post(`/api/v1/users/${id}/impersonate`), setLoading, setData, setError);
};

//organizations
export const getUserOrganizations = (filters, pagination, setLoading, setData, setError) => {
  return handleRequest((params) => axiosInstance.get('/api/v1/organizations', { params }), setLoading, setData, setError, filters, pagination);
};

export const createOrganization = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/organizations', data), setLoading, setData, setError);
};

export const getOrganizationDetails = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get(`/api/v1/organizations/${id}`), setLoading, setData, setError);
};

export const updateOrganization = (id, data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.put(`/api/v1/organizations/${id}`, data), setLoading, setData, setError);
};

export const deleteOrganization = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.delete(`/api/v1/organizations/${id}`), setLoading, setData, setError);
};

export const getOrganizationMembers = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get(`/api/v1/organizations/${id}/members`), setLoading, setData, setError);
};

export const inviteUserToOrganization = (id, data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post(`/api/v1/organizations/${id}/members/invite`, data), setLoading, setData, setError);
};

//campaigns
export const getCampaigns = (filters, pagination, setLoading, setData, setError) => {
  return handleRequest((params) => axiosInstance.get('/api/v1/campaigns', { params }), setLoading, setData, setError, filters, pagination);
};

export const getCampaignsPromise = (params) => {
  return axiosInstance.get('/api/v1/campaigns', { params });
};

export const createCampaignPromise = (data) => {
  return axiosInstance.post('/api/v1/campaigns', data);
};

export const getCampaignByIdPromise = (id) => {
  return axiosInstance.get(`/api/v1/campaigns/${id}`);
};

export const updateCampaignPromise = (id, data) => {
  return axiosInstance.patch(`/api/v1/campaigns/${id}`, data);
};

export const deleteCampaignPromise = (id) => {
  return axiosInstance.delete(`/api/v1/campaigns/${id}`);
};

export const startCampaignPromise = (id) => {
  return axiosInstance.post(`/api/v1/campaigns/${id}/start`);
};

export const pauseCampaignPromise = (id) => {
  return axiosInstance.post(`/api/v1/campaigns/${id}/pause`);
};

export const resumeCampaignPromise = (id) => {
  return axiosInstance.post(`/api/v1/campaigns/${id}/resume`);
};

export const stopCampaignPromise = (id) => {
  return axiosInstance.post(`/api/v1/campaigns/${id}/stop`);
};

export const getCampaignPerformancePromise = (id) => {
  return axiosInstance.get(`/api/v1/campaigns/${id}/performance`);
};

export const getCampaignSequencePerformancePromise = (id) => {
  return axiosInstance.get(`/api/v1/campaigns/${id}/sequence-performance`);
};

export const getCampaignSenderPerformancePromise = (id, params) => {
  return axiosInstance.get(`/api/v1/campaigns/${id}/sender-performance`, { params });
};

export const getCampaignLeadsPromise = (id, params) => {
  return axiosInstance.get(`/api/v1/campaigns/${id}/leads`, { params });
};

export const exportCampaignLeadsPromise = (id) => {
  return axiosInstance.post(`/api/v1/campaigns/${id}/leads/export`, null, { responseType: 'blob' });
};

export const removePendingCampaignLeadsPromise = (id) => {
  return axiosInstance.delete(`/api/v1/campaigns/${id}/leads/pending`);
};

// sequences
export const getSequencesPromise = (params) => {
  return axiosInstance.get('/api/v1/sequences', { params });
};

export const createSequencePromise = (data) => {
  return axiosInstance.post('/api/v1/sequences', data);
};

export const getSequenceByIdPromise = (id) => {
  return axiosInstance.get(`/api/v1/sequences/${id}`);
};

export const updateSequencePromise = (id, data) => {
  return axiosInstance.put(`/api/v1/sequences/${id}`, data);
};

export const validateSequencePromise = (steps) => {
  return axiosInstance.post('/api/v1/sequences/validate', { steps });
};

export const getSequenceTemplatesPromise = () => {
  return axiosInstance.get('/api/v1/sequences/templates/all');
};

export const createSequenceFromTemplatePromise = (templateId, data) => {
  return axiosInstance.post(`/api/v1/sequences/templates/${templateId}/create`, data);
};

// exclude lists
export const getExcludeListsPromise = (params) => {
  return axiosInstance.get('/api/v1/exclude-lists', { params });
};

export const createExcludeListPromise = (data) => {
  return axiosInstance.post('/api/v1/exclude-lists', data);
};

export const getExcludeListByIdPromise = (id) => {
  return axiosInstance.get(`/api/v1/exclude-lists/${id}`);
};

export const deleteExcludeListPromise = (id) => {
  return axiosInstance.delete(`/api/v1/exclude-lists/${id}`);
};

export const importExcludeListEntriesPromise = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axiosInstance.post(`/api/v1/exclude-lists/${id}/entries/import`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

//lead lists
export const getLeadListsPromise = (params) => {
  return axiosInstance.get('/api/v1/lead-lists', { params });
}

export const createLeadListPromise = (data) => {
  return axiosInstance.post('/api/v1/lead-lists', data);
}

export const getLeadListByIdPromise = (listId) => {
  return axiosInstance.get(`/api/v1/lead-lists/${listId}`);
}

export const updateLeadListPromise = (listId, data) => {
  return axiosInstance.patch(`/api/v1/lead-lists/${listId}`, data);
}

export const deleteLeadListPromise = (listId) => {
  return axiosInstance.delete(`/api/v1/lead-lists/${listId}`);
}

export const getLeadListsStatsPromise = (params) => {
  return axiosInstance.get('/api/v1/lead-lists/stats', { params });
}

//leads (nested under a lead list)
export const getLeadsPromise = (listId, params) => {
  return axiosInstance.get(`/api/v1/lead-lists/${listId}/leads`, { params });
}

export const getLeadByIdPromise = (listId, id) => {
  return axiosInstance.get(`/api/v1/lead-lists/${listId}/leads/${id}`);
}

export const createLeadPromise = (listId, data) => {
  return axiosInstance.post(`/api/v1/lead-lists/${listId}/leads`, data);
}

export const updateLeadPromise = (listId, id, data) => {
  return axiosInstance.patch(`/api/v1/lead-lists/${listId}/leads/${id}`, data);
}

export const deleteLeadPromise = (listId, id) => {
  return axiosInstance.delete(`/api/v1/lead-lists/${listId}/leads/${id}`);
}

export const deleteLeadsPromise = (listId, ids) => {
  // Bulk delete: loop through IDs
  return Promise.all(ids.map((id) => axiosInstance.delete(`/api/v1/lead-lists/${listId}/leads/${id}`)));
}

export const importLeadsFromCSV = (listId, formData) => {
  return axiosInstance.post(`/api/v1/lead-lists/${listId}/leads/import/csv`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export const importLeadsFromLinkedInSearch = (listId, data) => {
  return axiosInstance.post(`/api/v1/lead-lists/${listId}/leads/import/linkedin-search`, {
    limit: 1000,
    ...data,
  });
}

export const cancelLeadListImport = (listId) => {
  return axiosInstance.post(`/api/v1/lead-lists/${listId}/leads/import/cancel`);
}

export const updateLeadConnectionStatus = (listId, id, data) => {
  return axiosInstance.patch(`/api/v1/lead-lists/${listId}/leads/${id}/connection-status`, data);
}

export const updateLeadMessageStatus = (listId, id, data) => {
  return axiosInstance.patch(`/api/v1/lead-lists/${listId}/leads/${id}/message-status`, data);
}


//linkedin accounts
export const getLinkedInAccounts = (params) => {
  return axiosInstance.get('/api/v1/linkedin-accounts', { params });
};

export const createLinkedInAccount = (data) => {
  return axiosInstance.post('/api/v1/linkedin-accounts', data);
};

export const getLinkedInAccountById = (id) => {
  return axiosInstance.get(`/api/v1/linkedin-accounts/${id}`);
};

export const retryLinkedInProxyProvision = (id) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/retry-proxy-provision`, {});
};

export const updateLinkedInAccount = (id, data) => {
  return axiosInstance.patch(`/api/v1/linkedin-accounts/${id}`, data);
};

export const deleteLinkedInAccount = (id) => {
  return axiosInstance.delete(`/api/v1/linkedin-accounts/${id}`);
};

export const connectLinkedInAccount = (id) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/connect`, {}, { timeout: 180000 });
};

export const disconnectLinkedInAccount = (id) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/disconnect`, {});
};

export const challengeLinkedInAccount = (id, data) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/challenge`, data, { timeout: 180000 });
};

export const requestLinkedInEmailOtp = (id) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/request-email-otp`, {}, { timeout: 180000 });
};

export const rotateLinkedInIp = (id) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/rotate-ip`, {});
};

export const testLinkedInAccountConnection = (id) => {
  return axiosInstance.post(`/api/v1/linkedin-accounts/${id}/test-connection`, {}, { timeout: 180000 });
};

export const getLinkedInAccountStats = (id) => {
  return axiosInstance.get(`/api/v1/linkedin-accounts/${id}/stats`);
};

//webhooks
export const getWebhooks = (filters, pagination, setLoading, setData, setError) => {
  return handleRequest((params) => axiosInstance.get('/api/v1/webhooks', { params }), setLoading, setData, setError, filters, pagination);
};

export const createWebhook = (data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.post('/api/v1/webhooks', data), setLoading, setData, setError);
};

export const getWebhookById = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.get(`/api/v1/webhooks/${id}`), setLoading, setData, setError);
};

export const updateWebhook = (id, data, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.patch(`/api/v1/webhooks/${id}`, data), setLoading, setData, setError);
};

export const deleteWebhook = (id, setLoading, setData, setError) => {
  return handleRequest(() => axiosInstance.delete(`/api/v1/webhooks/${id}`), setLoading, setData, setError);
};

//messages
export const getMessages = (params) => {
  return axiosInstance.get('/api/v1/messages', { params });
};

export const getMessageThreads = (params) => {
  return axiosInstance.get('/api/v1/messages/threads', { params });
};

export const getMessageById = (id) => {
  return axiosInstance.get(`/api/v1/messages/${id}`);
};

export const createMessage = (data) => {
  return axiosInstance.post('/api/v1/messages', data);
};

export const sendMessage = (data) => {
  return axiosInstance.post('/api/v1/messages/send', data);
};

export const replyToMessage = (parentMessageId, data) => {
  return axiosInstance.post(`/api/v1/messages/${parentMessageId}/reply`, data);
};

export const updateMessage = (id, data) => {
  return axiosInstance.patch(`/api/v1/messages/${id}`, data);
};

export const deleteMessage = (id) => {
  return axiosInstance.delete(`/api/v1/messages/${id}`);
};

export const getMessageThread = (threadId) => {
  return axiosInstance.get(`/api/v1/messages/threads/${threadId}`);
};

export const markThreadRead = (threadId, data = {}) => {
  return axiosInstance.patch(`/api/v1/messages/threads/${threadId}/read`, data);
};

export const favoriteThread = (threadId) => {
  return axiosInstance.post(`/api/v1/messages/threads/${threadId}/favorite`);
};

export const unfavoriteThread = (threadId) => {
  return axiosInstance.delete(`/api/v1/messages/threads/${threadId}/favorite`);
};

export const syncInboxMessages = (data = {}) => {
  return axiosInstance.post('/api/v1/messages/sync', data);
};

export const getInboxSyncStatus = () => {
  return axiosInstance.get('/api/v1/messages/sync/status');
};

//analytics
export const getDashboardAnalytics = () => {
  return axiosInstance.get('/api/v1/analytics/dashboard');
};

export const getLeadsAnalytics = () => {
  return axiosInstance.get('/api/v1/analytics/leads');
};

export const getMessagesAnalytics = () => {
  return axiosInstance.get('/api/v1/analytics/messages');
};

export const getCampaignAnalytics = (id) => {
  return axiosInstance.get(`/api/v1/analytics/campaigns/${id}`);
};

//files
export const uploadFile = (file, setLoading, setData, setError, isPublic = true, customName = Date.parse(new Date()).toString(), description = "") => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('isPublic', isPublic);
  formData.append('customName', customName);
  if (description) formData.append('description', description);

  return handleRequest(() => axiosInstance.post('/api/v1/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }), setLoading, setData, setError);
};

/** Authenticated private-file bytes (JWT via axios) → object URL for <audio>/<img>. */
export const getPrivateFileObjectUrl = async (fileId) => {
  const response = await axiosInstance.get(`/api/v1/files/private/${fileId}`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};